
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M4.002 1.45a2.617 2.617 0 012.666 4.436 3.931 3.931 0 012.049 2.267.75.75 0 01-.709.997H2a.75.75 0 01-.708-.997 3.932 3.932 0 012.047-2.267 2.615 2.615 0 01.663-4.437zm1.001 1.3a1.117 1.117 0 100 2.234 1.117 1.117 0 000-2.234zM10 10.85a2.617 2.617 0 00-1.664 4.637 3.93 3.93 0 00-2.048 2.266.75.75 0 101.416.495 2.431 2.431 0 014.591 0 .75.75 0 101.416-.495 3.932 3.932 0 00-2.048-2.266A2.616 2.616 0 0010 10.85zm-.79 1.828a1.116 1.116 0 111.58 1.578 1.116 1.116 0 01-1.58-1.579zM3.596 7.465a2.432 2.432 0 013.046.185H3.367a2.43 2.43 0 01.229-.185zm9.55-5.449a2.617 2.617 0 113.514 3.87 3.933 3.933 0 012.048 2.267.75.75 0 01-.708.997h-6.008a.75.75 0 01-.709-.997 3.932 3.932 0 012.049-2.267 2.617 2.617 0 01-.186-3.87zm1.85.734a1.117 1.117 0 100 2.234 1.117 1.117 0 000-2.234zm-1.408 4.715a2.432 2.432 0 013.045.185h-3.275c.073-.066.15-.127.23-.185zM4.133 9.784a.75.75 0 01.75.75V13.2a.85.85 0 00.85.85h.533a.75.75 0 010 1.5h-.533a2.35 2.35 0 01-2.35-2.35v-2.666a.75.75 0 01.75-.75zm12.484.75a.75.75 0 00-1.5 0V13.2a.85.85 0 01-.85.85h-.534a.75.75 0 000 1.5h.534a2.35 2.35 0 002.35-2.35v-2.666z"}})])
          )
        }
      }
    